import { Stack, styled } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

interface EntityViewContentValueRowProps {
    icon?: ReactNode;
}

export default function EntityViewContentValueRow({ children, icon }: PropsWithChildren<EntityViewContentValueRowProps>) {
    return (
        <Root>
            { icon }
            { children }
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    gap: theme.spacing(2),
    flexDirection: 'row',
    alignItems: 'center',
    whiteSpace: 'pre-wrap',
    textOverflow: 'elipsis',

    svg: {
        fontSize: '16px'
    }
}));
